var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b(
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.enablePrint || !_vm.$isPrint,
            expression: "enablePrint || !$isPrint",
          },
        ],
        attrs: { role: "tablist" },
      },
      "div",
      _vm._d({}, [_vm.ariaLabelAttrName, _vm.ariaLabelAttr])
    ),
    [
      _vm.useRouter
        ? _vm._l(_vm.tabs, function (tab) {
            return _c("router-link", {
              key: tab.id,
              attrs: { to: tab.to, custom: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ href, navigate, isActive }) {
                      return [
                        _c(
                          "a",
                          {
                            ref: "tab",
                            refInFor: true,
                            class: _vm.classes(tab.id),
                            attrs: {
                              id: _vm.getTabElementId(_vm.tabsId, tab.id),
                              role: "tab",
                              "data-activeroute": isActive,
                              "data-tabid": tab.id,
                              href: href,
                              tabindex: _vm.tabIndexAttr(tab.id),
                              "aria-selected": _vm.ariaSelectedAttr(tab.id),
                              "aria-controls": _vm.ariaControlsAttr(tab.id),
                            },
                            on: {
                              click: (event) =>
                                _vm.onClick(tab.id, navigate, event),
                            },
                          },
                          [
                            _vm._t(
                              "tab",
                              function () {
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(tab.label) +
                                      "\n        "
                                  ),
                                ]
                              },
                              { tab: tab, isActive: _vm.isTabActive(tab.id) }
                            ),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          })
        : _vm._l(_vm.tabs, function (tab) {
            return _c(
              "button",
              {
                key: tab.id,
                ref: "tab",
                refInFor: true,
                class: _vm.classes(tab.id),
                attrs: {
                  id: _vm.getTabElementId(_vm.tabsId, tab.id),
                  type: "button",
                  role: "tab",
                  tabindex: _vm.tabIndexAttr(tab.id),
                  "aria-selected": _vm.ariaSelectedAttr(tab.id),
                  "aria-controls": _vm.ariaControlsAttr(tab.id),
                },
                on: {
                  click: function ($event) {
                    return _vm.onClick(tab.id)
                  },
                },
              },
              [
                _vm._t(
                  "tab",
                  function () {
                    return [
                      _vm._v("\n        " + _vm._s(tab.label) + "\n      "),
                    ]
                  },
                  { tab: tab, isActive: _vm.isTabActive(tab.id) }
                ),
              ],
              2
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }